import { FormWithRedux } from '../../FormWithRedux';

export class ACCBISTOrientationCheck3Form extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('orientationCheck3Subform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        return true;
    }

    getValueType(identifier) {
        return 'boolean';
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-OrientationCheck3Form.js